import { useEffect, useState } from 'react'
import { api, ApiError, formatDateBR } from '../api'
import type { ReportSummary } from '../api'

const COLS = '92px 92px 1.5fr 1.1fr 1.2fr 100px'

// Lista de laudos, do mais recente para o mais antigo: é a entrada da seção
// Laudos e para onde o "voltar" do laudo aberto retorna.
export function Laudos({ onOpenReport }: { onOpenReport: (id: string) => void }) {
  const [q, setQ] = useState('')
  const [items, setItems] = useState<ReportSummary[]>([])
  const [total, setTotal] = useState(0)
  const [loaded, setLoaded] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    const t = setTimeout(() => {
      const params: Record<string, string> = { limit: '200' }
      if (q.trim()) params.q = q.trim()
      api.reports.list(params)
        .then((out) => { setItems(out.items); setTotal(out.total); setError('') })
        .catch((err) => setError(err instanceof ApiError ? err.message : 'falha ao carregar laudos'))
        .finally(() => setLoaded(true))
    }, 200)
    return () => clearTimeout(t)
  }, [q])

  return (
    <div style={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', minHeight: 0, background: 'var(--surface)' }}>
      <div style={{ flex: 'none', display: 'flex', alignItems: 'center', gap: 12, padding: '10px 12px', borderBottom: '1px solid var(--border)' }}>
        <input className="input" autoFocus placeholder="Buscar" value={q} onChange={(e) => setQ(e.target.value)} style={{ width: 300 }} />
        <span style={{ font: '400 11.5px/1 var(--font-mono)', color: 'var(--text-3)' }}>{total}</span>
      </div>

      {error && <div style={{ flex: 'none', padding: '8px 12px', background: 'var(--danger-soft)', color: 'var(--danger)', fontSize: 12 }}>{error}</div>}

      <div style={{ flex: 1, overflow: 'auto', minHeight: 0 }}>
        <div style={{ display: 'grid', gridTemplateColumns: COLS, padding: '7px 12px', borderBottom: '1px solid var(--border)', background: 'var(--surface-2)', position: 'sticky', top: 0, font: '600 9.5px/1.2 var(--font-sans)', letterSpacing: '.06em', textTransform: 'uppercase', color: 'var(--text-3)' }}>
          <div>Data</div><div>Laudo Nº</div><div>Paciente</div><div>Exame</div><div>Examinador</div><div>Status</div>
        </div>
        {items.map((r) => (
          <div key={r.id} onClick={() => onOpenReport(r.id)}
            style={{ display: 'grid', gridTemplateColumns: COLS, padding: '9px 12px', borderBottom: '1px solid var(--border)', cursor: 'pointer', alignItems: 'center', font: '400 12px/1.3 var(--font-sans)' }}>
            <div style={{ fontFamily: 'var(--font-mono)' }}>{formatDateBR(r.examDate)}</div>
            <div style={{ fontFamily: 'var(--font-mono)', fontWeight: 500 }}>{r.number}</div>
            <div style={{ fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.patientName}</div>
            <div style={{ color: 'var(--text-2)' }}>{r.model}</div>
            <div style={{ color: 'var(--text-2)' }}>{r.professionalName || '—'}</div>
            <div>
              <span className="badge" style={{ background: r.status === 'liberado' ? 'var(--ok-soft)' : 'var(--accent-soft)', color: r.status === 'liberado' ? 'var(--ok)' : 'var(--accent)' }}>
                {r.status === 'liberado' ? 'LIBERADO' : 'RASCUNHO'}
              </span>
            </div>
          </div>
        ))}
        {loaded && items.length === 0 && (
          <div style={{ padding: '40px 16px', textAlign: 'center', font: '400 12px/1.7 var(--font-mono)', color: 'var(--text-3)' }}>
            Nenhum laudo
          </div>
        )}
      </div>
    </div>
  )
}
